import axiosClient from './axiosClient';

const alarmController = {
  tb_getAlarms(token, entityType, entityId, page, pageSize, startTs, endTs) {
    const url = `/api/alarm/${entityType}/${entityId}?pageSize=${pageSize}&page=${page}&startTime=${startTs}&endTime=${endTs}&sortProperty=createdTime&sortOrder=DESC&searchStatus=ANY&fetchOriginator=true`;
    return axiosClient.get(url, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    });
  },
};

export default alarmController;
